exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n * Variables\n */\n\n/**\n * Functions\n */\n.register[data-v-0c3e6977] {\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-ms-flex-direction: column;\n\tflex-direction: column;\n\tgap: 48px;\n\tgap: 3rem;\n}\n", ""]);

// exports
